import React from 'react';
import '@fontsource/inter';
import '@fortawesome/fontawesome-free/css/all.min.css';

import PageNotSpotted from '../../../Components/PageNotSpotted';
import { GameType } from '../../../Utils';
import './TrialBaccarat.scss';
import { GameEngine } from '../../../Components/GameEngine';

const TrialBaccarat = () => {
  return (
    <>
      <GameEngine
        title='百家乐 Baccarat'
        containerClass='homebaccarat'
        gameType={GameType.Baccarat}
        trial={true}
      />
      <PageNotSpotted />
    </>
  );
};

export default TrialBaccarat;
